export default __webpack_public_path__ + "static/twk-lausanne-light-ac6ef794496ed539db093b12fea19cd8.woff";